var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutmeIcoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5C13 14.3284 12.5523 15 12 15C11.4477 15 11 14.3284 11 13.5C11 12.6716 11.4477 12 12 12C12.5523 12 13 12.6716 13 13.5Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.5C19 14.3284 18.5523 15 18 15C17.4477 15 17 14.3284 17 13.5C17 12.6716 17.4477 12 18 12C18.5523 12 19 12.6716 19 13.5Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.25C9.04216 4.25 4.25 9.21861 4.25 15.3006V22.723C4.25 24.5695 6.16246 25.8461 7.8426 24.9808C8.52425 24.6297 9.33486 24.6808 9.97157 25.1181C11.1986 25.9606 12.8014 25.9606 14.0284 25.1181L14.3811 24.8759C14.7572 24.6176 15.2428 24.6176 15.6189 24.8759L15.9716 25.1181C17.1986 25.9606 18.8014 25.9606 20.0284 25.1181C20.6651 24.6808 21.4757 24.6297 22.1574 24.9808C23.8375 25.8461 25.75 24.5695 25.75 22.723V15.3006C25.75 9.21861 20.9578 4.25 15 4.25ZM5.75 15.3006C5.75 10.0049 9.91215 5.75 15 5.75C20.0879 5.75 24.25 10.0049 24.25 15.3006V22.723C24.25 23.5212 23.4605 23.9647 22.8442 23.6472C21.6697 23.0424 20.2693 23.133 19.1793 23.8815C18.4639 24.3728 17.5361 24.3728 16.8207 23.8815L16.468 23.6394C15.5804 23.0298 14.4196 23.0298 13.532 23.6394L13.1793 23.8815C12.4639 24.3728 11.5361 24.3728 10.8207 23.8815C9.73074 23.133 8.33026 23.0424 7.1558 23.6472C6.53949 23.9647 5.75 23.5212 5.75 22.723V15.3006Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutmeIcoWhite);
export default __webpack_public_path__ + "static/media/aboutme-ico-white.a712fbe88793ce159934f5d9bdc2280f.svg";
export { ForwardRef as ReactComponent };